import { HOST_NAME } from '@data/config/url'

export const buildBreadcrumbList = (items: { name: string; url: string }[]) => {
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      ...(i < items.length - 1 ? { item: item.url } : {}),
    })),
  })
}

export const HOME_BREADCRUMB = { name: 'Home', url: HOST_NAME }
